/* Maps enriched Convex feed item results to the FeedItemData shape.
   Used by FeedItemsProvider and SwipePage to avoid duplicating the mapping logic. */

import type { FeedItemData } from "@/components/feed/FeedItemRow";

export function mapEnrichedFeedItem(raw: { _id: string; [key: string]: unknown }): FeedItemData {
  const item = raw as Record<string, unknown>;
  return {
    _id: raw._id,
    title: item.title as string,
    thumbnail: (item.thumbnail as string | undefined) ?? undefined,
    sourceName: (item.sourceName as string | undefined) ?? undefined,
    sourceTags: (item.sourceTags as string[] | undefined) ?? undefined,
    contentType: (item.contentType as string | undefined) ?? undefined,
    sourceStarred: (item.sourceStarred as boolean | undefined) ?? undefined,
    publishedAt: item.publishedAt as number,
    link: item.link as string,
    duration: (item.duration as number | undefined) ?? undefined,
    isProvocative: (item.isProvocative as boolean | undefined) ?? undefined,
    note: (item.note as string | undefined) ?? undefined,
    bookAuthor: (item.bookAuthor as string | undefined) ?? undefined,
    bookTotalPages: (item.bookTotalPages as number | undefined) ?? undefined,
    bookCover: (item.bookCover as string | undefined) ?? undefined,
    bookPagesPerDay: (item.bookPagesPerDay as number | undefined) ?? undefined,
    bookCurrentPage: (item.bookCurrentPage as number | undefined) ?? undefined,
    bookPageStart: (item.bookPageStart as number | undefined) ?? undefined,
    bookPageEnd: (item.bookPageEnd as number | undefined) ?? undefined,
    movieImdbId: (item.movieImdbId as string | undefined) ?? undefined,
    movieDirector: (item.movieDirector as string | undefined) ?? undefined,
    movieYear: (item.movieYear as string | undefined) ?? undefined,
    movieGenres: (item.movieGenres as string | undefined) ?? undefined,
    movieRuntime: (item.movieRuntime as string | undefined) ?? undefined,
    movieRating: (item.movieRating as string | undefined) ?? undefined,
    moviePoster: (item.moviePoster as string | undefined) ?? undefined,
    moviePlot: (item.moviePlot as string | undefined) ?? undefined,
    movieActors: (item.movieActors as string | undefined) ?? undefined,
    audioUrl: (item.audioUrl as string | undefined) ?? undefined,
    sourceId: (item.sourceId as string | undefined) ?? undefined,
    sourceSkipProvocationCheck: (item.sourceSkipProvocationCheck as boolean | undefined) ?? undefined,
    aiTopics: (item.aiTopics as string[] | undefined) ?? undefined,
    playlistName: (item.playlistName as string | undefined) ?? undefined,
    playlistVideoPosition: (item.playlistVideoPosition as number | undefined) ?? undefined,
    playlistTotalVideos: (item.playlistTotalVideos as number | undefined) ?? undefined,
    tvEpisodeTitle: (item.tvEpisodeTitle as string | undefined) ?? undefined,
    tvSeason: (item.tvSeason as number | undefined) ?? undefined,
    tvEpisode: (item.tvEpisode as number | undefined) ?? undefined,
    tvShowTitle: (item.tvShowTitle as string | undefined) ?? undefined,
    tvShowPoster: (item.tvShowPoster as string | undefined) ?? undefined,
    tvShowNetwork: (item.tvShowNetwork as string | undefined) ?? undefined,
  };
}
